 import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blankpage',
  templateUrl: './blankpage.component.html',
  styleUrls: ['./blankpage.component.css']
})
export class BlankpageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
